import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.background};
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const Heading = styled.h2`
  margin-bottom: 15px;
`;

const SubHeading = styled.h3`
  color: ${({ theme }) => theme.headerText};
  margin-top: 20px;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  margin-bottom: 10px;
  line-height: 1.6;
`;

const Image = styled.img`
  max-width: 100%; /* Ensure images don't overflow */
  height: auto; /* Maintain aspect ratio */
  display: block; /* Remove extra space below image */
  margin: 1.5em auto; /* Center images and add vertical spacing */
  border: 1px solid #ddd; /* A subtle border for images */
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1); /* Optional: add a subtle shadow */
`;

const List = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 15px;
`;

const ListItem = styled.li`
  margin-bottom: 5px;

  a {
    color: ${({ theme }) => theme.headerText};
  }
`;


const StyledTable = styled.table`
  border-collapse: collapse; /* Merges cell borders */
  table-layout: fixed; /* Ensures columns have fixed widths */
  width: 100%; /* Make the table responsive to its container width */
  max-width: 1200px; /* Max width to prevent it from getting too wide */
  margin: 2rem auto; /* Center the table and give it some vertical space */
  font-family: 'Arial', sans-serif; /* A clear, readable font */
  color: ${({ theme }) => theme.text}; /* Text color from theme */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for the table */
  border-radius: 8px; /* Rounded corners for the table */
  overflow: hidden; /* Ensures shadow/border-radius apply correctly */
`;

const StyledTableHeaderCell = styled.th`
  background-color: ${({ theme }) => theme.primary }; /* Header background color */
  color: ${({ theme }) => theme.headerText }; /* Header text color */
  padding: 12px 15px;
  text-align: left;
  font-weight: bold;
  border: 1px solid ${({ theme }) => theme.tableBorder }; /* Border for header cells */
  white-space: nowrap; /* Prevent headers from wrapping too much */
`;

const StyledTableCell = styled.td`
  padding: 10px 15px;
  border: 1px solid ${({ theme }) => theme.tableBorder}; /* Border for regular cells */
  text-align: left;
  background-color: ${({ theme }) => theme.tableBg }; /* Cell background */
  vertical-align: top; /* Align text to the top of the cell */
  word-wrap: break-word; /* Allows long words to break and wrap */

  &:first-child {
    font-weight: ${({ isHeader }) => (isHeader ? 'bold' : 'normal')}; /* Apply bold to first column cells if they act as row headers */
    background-color: ${({ theme }) => theme.tableRowHeaderBg }; /* Slightly different background for the first column */
  }
`;

const StyledTableRow = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.tableStriping }; /* Zebra striping for readability */
  }
  &:hover ${StyledTableCell} {
    background-color: ${({ theme }) => theme.tableHover }; /* Hover effect for rows */
  }
`;

const TemplateFieldsTable = ({ title, fields }) => (
  <Section>
    <SubHeading>{title}</SubHeading>
    <StyledTable> {/* Using StyledTable here */}
      <thead>
        <tr>
          <StyledTableHeaderCell>Field #</StyledTableHeaderCell>
          <StyledTableHeaderCell>Source Name</StyledTableHeaderCell>
          <StyledTableHeaderCell>Target Name</StyledTableHeaderCell>
          <StyledTableHeaderCell>Description</StyledTableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => (
          <StyledTableRow key={index}> {/* Using StyledTableRow here */}
            <StyledTableCell>{field['Field #']}</StyledTableCell> {/* Using StyledTableCell here */}
            <StyledTableCell>{field['Source Name']}</StyledTableCell>
            <StyledTableCell>{field['Target Name']}</StyledTableCell>
            <StyledTableCell>{field.Description}</StyledTableCell>
          </StyledTableRow>
        ))}
      </tbody>
    </StyledTable>
  </Section>
);


// --- NEW: Component to render the four-column data table ---
const CustomFourColumnTable = ({ data }) => (
  <StyledTable className="table_template">
    <thead>
      <StyledTableRow>
        {data[0].map((header, index) => (
          <StyledTableHeaderCell key={index}>{header}</StyledTableHeaderCell>
        ))}
      </StyledTableRow>
    </thead>
    <tbody>
      {data.slice(1).map((row, rowIndex) => (
        <StyledTableRow key={rowIndex}>
          {row.map((cell, cellIndex) => (
            <StyledTableCell key={cellIndex} isHeader={cellIndex === 0}>
              {cell}
            </StyledTableCell>
          ))}
        </StyledTableRow>
      ))}
    </tbody>
  </StyledTable>
);
// --- END NEW COMPONENT ---


const Abhs2019Content = () => {
  const tableData = [
    ['Final Fields', 'Source Fields', 'Source Fields', 'Source Fields'], // Header row
    ['All Herds - 2019', 'Herd 27', 'Herd 28', 'Herd 29'],
    ['CIPARS', 'CIPARS', 'Feedlot', 'Feedlot'],
    ['Code', 'Code', 'Code', 'Code'],
    ['Sex', 'Sex', 'Sex', 'Hd In'],
    ['Type', 'Type', 'Type', 'Type'],
    ['Origin', 'Origin', 'Origin', 'Sex'],
    ['Weaned', 'Weaned', 'Weaned', 'Weaned'],
    ['BRD Risk', 'BRD Risk', 'BRD risk', 'Source'],
    ['# HD IN', '# HD IN', 'In Wt (lbs)', 'BRD Risk'],
    ['In Date', 'In Date', 'Hd IN', 'In Date'],
    ['Total InWt (lb)', 'Total InWt (lb)', 'In Date', 'In Wt (lbs)'],
    ['Ave. In Wt (lbs)', 'Ave. In Wt (lbs)', 'Ave Out Wt (lbs)', 'Hd In'],
    ['ave ship date', 'ave ship date', 'Out Date', 'Ave Out Wt (lbs)'],
    ['Slaughter Date', 'Slaughter Date', 'Quarter closed', 'Ave. Out Date'],
    ['Quarter closed', 'Quarter closed', 'Hd Out', 'Hd Out'],
    ['Sale Wt (lb)', 'Sale Wt (lb)', 'Deads', 'Deads'],
    ['Total Out Wt (lb)', 'Total Out Wt (lb)', 'DOF', 'DOF'],
    ['Ave. Out Wt (lbs)', 'Ave. Out Wt (lbs)', 'DDMI (lb/day)', 'DDMI (lb/day)'],
    ['Deads', 'Deads', 'Head Days', 'Head Days'],
    ['Head Out', 'Head Out', 'tulathromycin (ml)', 'tulathromycin (ml)'],
    ['DOF', 'DOF', 'tulathromycin (mg)', 'tulathromycin (mg)'],
    ['Head Days', 'Head Days', 'gamithromycin (ml)', 'gamithromycin (ml)'],
    ['DDMI (lb/day)', 'tulathromycin (ml)', 'gamthromycin (mg)', 'gamthromycin (mg)'],
    ['tulathromycin (ml)', 'tulathromycin (mg)', 'tilmicosin (ml)', 'tilmicosin (ml)'],
    ['tulathromycin (mg)', 'gamithromycin (ml)', 'tilmicosin (mg)', 'tilmicosin (mg)'],
    ['gamithromycin (ml)', 'gamthromycin (mg)', 'danofloxacin (ml)', 'danofloxacin (ml)'],
    ['gamthromycin (mg)', 'tilmicosin (ml)', 'danofloxacin (mg)', 'danofloxacin (mg)'],
    ['tilmicosin (ml)', 'tilmicosin (mg)', 'enrofloxacin (ml)', 'enrofloxacin (ml)'],
    ['tilmicosin (mg)', 'danofloxacin (ml)', 'enrofloxacin (mg)', 'enrofloxacin (mg)'],
    ['danofloxacin (ml)', 'danofloxacin (mg)', 'oxytetracycline (ml)', 'oxytetracycline (ml)'],
    ['danofloxacin (mg)', 'enrofloxacin (ml)', 'enrofloxacin (mg)', 'enrofloxacin (mg)'],
    ['enrofloxacin (ml)', 'enrofloxacin (mg)', 'ceftiofur-crystalline free acid (ml)', 'ceftiofur-crystalline free acid (ml)'],
    ['enrofloxacin (mg)', 'oxytetracycline (ml)', 'ceftiofur cyrstalline (mg)', 'ceftiofur cyrstalline (mg)'],
    ['oxytetracycline (ml)', 'enrofloxacin (mg)', 'ceftiofur sodium powder (ml)', 'ceftiofur sodium powder (ml)'],
    ['oxytetracycline (mg)', 'ceftiofur-crystalline free acid (ml)', 'ceftiofur sodium (mg)', 'ceftiofur sodium (mg)'],
    ['ceftiofur-crystalline free acid (ml)', 'ceftiofur cyrstalline (mg)', 'procaine penicillin G (ml)', 'procaine penicillin G (ml)'],
    ['ceftiofur cyrstalline (mg)', 'ceftiofur sodium powder (ml)', 'procaine penicillin G (mg)', 'procaine penicillin G (mg)'],
    ['ceftiofur sodium powder (ml)', 'ceftiofur sodium (mg)', 'Florfenicol (ml)', 'Florfenicol (ml)'],
    ['ceftiofur sodium (mg)', 'procaine penicillin G (ml)', 'florfenicol (mg)', 'florfenicol (mg)'],
    ['procaine penicillin G (ml)', 'procaine penicillin G (mg)', 'Trimethoprim-sulfadoxine (ml)', 'Trimethoprim-sulfadoxine (ml)'],
    ['procaine penicillin G (mg)', 'Florfenicol (ml)', 'TMP-Sulfa (mg TMP)', 'TMP-Sulfa (mg TMP)'],
    ['Florfenicol (ml)', 'florfenicol (mg)', 'TMP-Sulfa (mg Sulfadoxine)', 'TMP-Sulfa (mg Sulfadoxine)'],
    ['florfenicol (mg)', 'Trimethoprim-sulfadoxine (ml)', 'marbofloxacin (ml)', 'marbofloxacin (ml)'],
    ['Trimethoprim-sulfadoxine (ml)', 'TMP-Sulfa (mg TMP)', 'marbofloxacin (mg)', 'marbofloxacin (mg)'],
    ['TMP-Sulfa (mg TMP)', 'TMP-Sulfa (mg Sulfadoxine)', 'Total Mg Parenteral AM', 'Sulfa boluses'],
    ['TMP-Sulfa (mg Sulfadoxine)', 'Total Mg Parenteral AM', 'monensin sodium (mg)', 'sulfamethazine (mg)'],
    ['marbofloxacin (ml)', 'monensin sodium (mg)', 'tylosin phosphate (mg)', 'Total Mg Parenteral AM'],
    ['marbofloxacin (mg)', 'tylosin phosphate (mg)', 'Chlortetracycline HCL', 'monensin sodium (mg)'],
    ['Sulfa boluses', 'Chlortetracycline HCL', '', 'tylosin phosphate (mg)'], // Note: Added empty string for third column
    ['sulfamethazine (mg)', 'Chlortetracycline HCL (mg)', '', ''], // Note: Adjusted for specific colspan in original
    ['monensin sodium (mg)', '', '', ''],
    ['tylosin phosphate (mg)', '', '', ''],
    ['Chlortetracycline HCL', '', '', ''],
    ['Total Mg Parenteral AM', '', '', ''],
  ];
  // Data for the 'Beef Cattle Study: Template Fields: Core Fields' table
  const coreFields = [
    { 'Field #': 1, 'Source Name': 'ssrow', 'Target Name': 'ssrow', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 2, 'Source Name': 'ssgroup', 'Target Name': 'ssgroup', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 3, 'Source Name': 'cipars', 'Target Name': 'cipars', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 4, 'Source Name': 'code', 'Target Name': 'csb_pl_production_lot_code', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 5, 'Source Name': 'sex', 'Target Name': 'csb_pl_sex_id', 'Description': 'Setup Lookup Field (2)survey_cattle_beef.lu_pl_sex' },
    { 'Field #': 6, 'Source Name': 'type', 'Target Name': 'csb_pl_animal_age_category_id', 'Description': 'Setup Lookup Field (2)survey_cattle_beef.lu_pl_age_group' },
    { 'Field #': 7, 'Source Name': 'origin', 'Target Name': 'csb_pl_origin_id', 'Description': 'Setup Lookup Field (2)survey_cattle_beef.lu_pl_origin' },
    { 'Field #': 8, 'Source Name': 'weaned', 'Target Name': 'weaned', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 9, 'Source Name': 'brd_risk', 'Target Name': 'csb_pl_brd_risk_id', 'Description': 'Setup Lookup Field (2)survey_cattle_beef.lu_pl_brd_risk' },
    { 'Field #': 10, 'Source Name': 'hd_in', 'Target Name': 'csb_pl_n_animals_in', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 11, 'Source Name': 'in_date', 'Target Name': 'csb_pl_avg_date_in', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 12, 'Source Name': 'total_inwt_lb', 'Target Name': 'total_inwt_lb', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 13, 'Source Name': 'ave_in_wt_lbs', 'Target Name': 'csb_pl_avg_weight_in_kgs', 'Description': 'Setup Multiple Target Fields (3)' },
    { 'Field #': 14, 'Source Name': 'ave_ship_date', 'Target Name': 'csb_pl_avg_date_out', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 15, 'Source Name': 'slaughter_date', 'Target Name': 'slaughter_date', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 16, 'Source Name': 'quarter_closed', 'Target Name': 'csb_pl_quarter_of_year_closeout_id', 'Description': 'Setup Lookup Field (2)survey_cattle_beef.lu_pl_season' },
    { 'Field #': 17, 'Source Name': 'sale_wt_lb', 'Target Name': 'sale_wt_lb', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 18, 'Source Name': 'total_out_wt_lb', 'Target Name': 'total_out_wt_lb', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 19, 'Source Name': 'ave_out_wt_lbs', 'Target Name': 'csb_pl_avg_weight_out_kgs', 'Description': 'Setup Multiple Target Fields (3)' },
    { 'Field #': 20, 'Source Name': 'deads', 'Target Name': 'csb_pl_n_animals_dead', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 21, 'Source Name': 'head_out', 'Target Name': 'csb_pl_n_animals_slaughtered', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 22, 'Source Name': 'dof', 'Target Name': 'csb_pl_total_days_on_feed', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 23, 'Source Name': 'head_days', 'Target Name': 'csb_pl_total_head_days', 'Description': 'Setup Standard Field (1)' },
    { 'Field #': 24, 'Source Name': 'ddmi_lbday', 'Target Name': 'ddmi_lbday', 'Description': 'Setup Standard Field (1)' },
  ];

  // Data for the 'Beef Cattle Study: Template Drug Fields: Active Ingredients' table
  const activeIngredientFields = [
    { 'Field #': 26, 'Source Name': 'tulathromycin_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Tulathromycin (LA) (100 mg/ml)' },
    { 'Field #': 28, 'Source Name': 'gamthromycin_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Gamithromycin (LA) (150 mg/ml)' },
    { 'Field #': 30, 'Source Name': 'tilmicosin_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Tilmicosin (300 mg/ml)' },
    { 'Field #': 32, 'Source Name': 'danofloxacin_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Danofloxacin (LA) (180 mg/ml)' },
    { 'Field #': 34, 'Source Name': 'enrofloxacin_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Enrofloxacin (100 mg/ml)' },
    { 'Field #': 36, 'Source Name': 'oxytetracycline_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Oxytetracycline (200 mg/ml)' },
    { 'Field #': 38, 'Source Name': 'ceftiofur_cyrstalline_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Ceftiofur (200 mg/ml)' },
    { 'Field #': 40, 'Source Name': 'ceftiofur_sodium_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Ceftiofur (50 mg/ml)' },
    { 'Field #': 42, 'Source Name': 'procaine_penicillin_g_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Procaine Penicillin G (300 mg/ml)' },
    { 'Field #': 44, 'Source Name': 'florfenicol_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Florfenicol (300 mg/ml)' },
    { 'Field #': 46, 'Source Name': 'tmpsulfa_mg_tmp', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Trimethoprim (40 mg/ml)' },
    { 'Field #': 47, 'Source Name': 'tmpsulfa_mg_sulfadoxine', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Sulfadoxine (200 mg/ml)' },
    { 'Field #': 49, 'Source Name': 'marbofloxacin_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Marbofloxacin (160 mg/ml)' },
    { 'Field #': 51, 'Source Name': 'sulfamethazine_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Sulfamethazine (32100 mg/bolus)' },
    { 'Field #': 52, 'Source Name': 'monensin_sodium_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Monensin' },
    { 'Field #': 53, 'Source Name': 'tylosin_phosphate_mg', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Tylosin' },
    { 'Field #': 54, 'Source Name': 'chlortetracycline_hcl', 'Target Name': 'csb_pl_drug_active_ingredient_id', 'Description': 'Chlortetracycline' },
  ];

  return (
    <Container>
      <Section>
        <Heading>Canadian Beef Cattle Survey</Heading>
        <SubHeading>Production Lot Upload Data Preparation: Alberta Health Solutions (ABHS)</SubHeading>
        <Paragraph><strong>Site Information Details</strong></Paragraph>
        <Paragraph><strong>Alberta Beef Health Solutions (ABHS)</strong></Paragraph>
        <Paragraph>Vet: CSBV00003 (3)</Paragraph>
        <Paragraph>Project Year: 2019</Paragraph>
        <Paragraph>The site has three (3) herds. They are:</Paragraph>
        <List>
          <ListItem>CSBH000027</ListItem>
          <ListItem>CSBH000028</ListItem>
          <ListItem>CSBH000029</ListItem>
        </List>

        <Paragraph>Access to current years documentation click on the appropriate link below:</Paragraph>
        <List>
          {/* Use Link component for internal navigation */}
          <ListItem><Link to="/beef/data-preparation/abhs2020">ABHS 2020</Link></ListItem>
          <ListItem><Link to="/beef/data-preparation/abhs2021">ABHS 2021</Link></ListItem>
        </List>

        <SubHeading>Production Lot Upload Data Preparation: Alberta Health Solutions (ABHS)</SubHeading>
        <Paragraph><strong>Data Source Information</strong></Paragraph>
        <Paragraph>ABHS has 3 herds.</Paragraph>
        <Paragraph>Each spreadsheet/workbook from ABHS represents a specific herd for a specific sampling year.</Paragraph>
        <Paragraph>Within the workbook there is usually just 2 drugs: feed and injectable (parenteral).</Paragraph>
        <Paragraph>The core fields in a sheet have the drug fields at the end of the core field data.</Paragraph>
        <Paragraph>The drug fields are assembled as columns in the spreadsheet.</Paragraph>

        <Paragraph>There are options how to setup each drug.</Paragraph>
        <Paragraph>Each drug sheet can have all associated Core fields and Drug fields together.</Paragraph>
        <Paragraph>Another option is to place all Drug field information, Feed and Injectable, at the end of the Core fields.</Paragraph>
        <Paragraph>Depending on what option is used, the setup of the upload templates will vary.</Paragraph>

        <Paragraph>Before creating and setting up a template, go thru all spreadsheets provided from the site.</Paragraph>
        <Paragraph>Collect field names from each site and put them together. Review the field names to make sure they all match. My experience is the field names do not match. To reduce the number of templates to create, get the field names to match. The fields do not need to be in the same order.</Paragraph>

        <Paragraph>The other reason to check all spreadsheets before creating a template is to see if there are the same number of drugs. I have discovered it is the case the # of columns of drugs are not the same or there are more drugs in a spreadsheet compared to another. To make it easier, prepare only 1 template, get all drugs together across all drug routes for all spreadsheet data. If you do it in this way, it is a possible route to introduce more errors. Be careful!</Paragraph>

        <SubHeading>ABHS 2019: Final Source Spreadsheet columns</SubHeading>
        {/* Here's where you put your CustomFourColumnTable */}
        <CustomFourColumnTable data={tableData} />

        <SubHeading>ABHS 2019: Reconcile Columns from Source Spreadsheets</SubHeading>
        <Image src="/images/ss_template_prep_abhs.png"/>
        <Paragraph>Production Lot Upload Data Preparation: Alberta Health Solutions (ABHS)</Paragraph>
        <Paragraph><strong>Template Setup Suggestions</strong></Paragraph>
        <Paragraph>A single upload Template can be setup for one or more years batch of data. For the current document, assume we place all drug known fields for all drug routes at the end of the core fields. When do this, then one Template is created. The Template is populated from a worksheet from a specific spreadsheet or workbook. The reason for this is because the drug fields are in columns not rows. The system is designed to deal with it but you must upload by Source data to get it to work correctly. The Template should be setup to have multiple or mix of drugs, data is by column and populated by source.</Paragraph>

        <Paragraph>Here are the typical template settings used for ABHS.</Paragraph>
        <List>
          <ListItem>Name: ABHS 2020 - Core and Injectable</ListItem>
          <ListItem>Level: Top Level</ListItem>
          <ListItem>Type: Both</ListItem>
          <ListItem>Route: Injectable</ListItem>
          <ListItem>Version: Version 1</ListItem>
          <ListItem>By Row or Column: By Column</ListItem>
        </List>
        <Image src="/images/ss_template_abhs_all_herds_2019.png"/>

        <SubHeading>ABHS Template Settings: Core and Injectables (Template Id=30)</SubHeading>
        <Paragraph><strong>Beef Cattle Study: Template Information</strong></Paragraph>
        <List>
          <ListItem>Template Id: 43 Development Server</ListItem>
          <ListItem>Template Name: ABHS 2019 - Core, Injectable, Bolus, Feed</ListItem>
          <ListItem>Group: Alberta Beef Health Solutions (2)</ListItem>
          <ListItem>Template Type: Both (3)</ListItem>
          <ListItem>Template Population: Populate template fields from Source (2)</ListItem>
          <ListItem>Template By Row or Column: By Column (2)</ListItem>
          <ListItem>Template Drug Route: Multiple Drugs (4)</ListItem>
          <ListItem>Template Level: Top Level (1)</ListItem>
          <ListItem>Template Version: Version 1 (1)</ListItem>
          <ListItem>Data by Row or Column: By Column (2)</ListItem>
          <ListItem>Template Created: 2021-03-26 20:37:14.251053+00</ListItem>
        </List>

        <TemplateFieldsTable
          title="Beef Cattle Study: Template Fields: Core Fields"
          fields={coreFields}
        />

        <TemplateFieldsTable
          title="Beef Cattle Study: Template Drug Fields: Active Ingredients"
          fields={activeIngredientFields}
        />

        <SubHeading>Beef Cattle Study: Template Drug Fields: Trade Names</SubHeading>
        {/* You mentioned "Trade Names" but didn't provide data for it. */}
        <Paragraph>Field #Field IdNot UsedSource NameSource TypeCategoryTarget NameTarget TypeDrug RouteSource Drug NameSource Drug UnitsTN Field NameStandard TN NameStandard TN Id</Paragraph>
      </Section>
    </Container>
  );
};

export default Abhs2019Content;